<template>
  <SkeletonAnimation>
    <div class="order-skeleton-component">
       <div class="back">
        <PartItem
        :styles="{
          width: '146px',
          height: '22px',
          'border-radius': '4px ',
        }"
      ></PartItem>
      </div>
      <div v-for="item in 4" :key="item" class="order-lists">
        <div class="order-title">
          <PartItem :style="block1" />
          <PartItem :style="block2" />
        </div>
        <div class="lists-infos">
          <div class="infos-left">
            <PartItem :style="block3" />
          </div>
          <div class="infos-right">
            <div class="infos-right_title">
              <PartItem :style="block4" />
              <PartItem :style="block5" />
            </div>
            <PartItem :style="block6" />
            <PartItem :style="block7" />
            <PartItem :style="block8" />
          </div>
        </div>
      </div>
    </div>
  </SkeletonAnimation>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
import PartItem from '../partItem.vue';

export default {
  name: 'OrderSkeleton',
  components: {
    SkeletonAnimation,
    PartItem,
  },
  data() {
    return {
      block1: {
        width: '240px',
        height: '18px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-bottom': '20px',
      },
      block2: {
        width: '122px',
        height: '14px',
        background: '#E5E5EB',
        'border-radius': '4px',
      },
      block3: {
        width: '160px',
        height: '120px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-right': '16px',
      },
      block4: {
        width: '434px',
        height: '18px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-right': '82px',
        'margin-bottom': '8px',
      },
      block5: {
        width: '160px',
        height: '24px',
        background: '#E5E5EB',
        'border-radius': '4px',
      },
      block6: {
        width: '280px',
        height: '22px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-bottom': '32px',
      },
      block7: {
        width: '230px',
        height: '12px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-bottom': '12px',
      },
      block8: {
        width: '84px',
        height: '14px',
        background: '#E5E5EB',
        'border-radius': '4px',
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.order-skeleton-component {
  width: 1156px;
  margin: 0 auto;
}
.back{
  height: 60px;
  display: flex;
  align-items: center;
  width: 1156px;
  margin: 0 auto;
}
.order-lists {
  height: 197.37px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}
.order-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lists-infos {
  display: flex;
}
.infos-right_title {
  display: flex;
}
</style>
